<template>
  <div v-title :data-title="$route.name">
    <!-- caseshipinzuixin -->
    <!-- style=" border-style: solid; border-width: 5px; border-color: transparent;" -->
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: white !important;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%"
          src="../assets/Battertimg/PC/casetop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 48px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%; /* 继承父级宽度 */
              text-align: center; /* 文本水平居中 */
            "
          >
            Gallery
          </div>
        </div>
      </div>
      <div style="width: 100%; text-align: center">
        <div
          style="
            position: relative;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            margin-top: 50px;
            margin-bottom: 100px;
          "
        >
          <div style="width: 1000px">
            <!-- 新增的动态布局部分 -->
            <div
              v-for="(row, rowIndex) in groupedRows"
              :key="rowIndex"
              class="row"
            >
              <!-- 模式A：左大图 + 右小图垂直排列（偶数行） -->
              <template v-if="rowIndex % 2 === 0">
                <div class="pattern-a">
                  <!-- 左侧大图 -->
                  <div class="cell large" v-if="row[0]">
                    <!-- 图片或视频 -->
                    <div v-if="row[0].type === 'image'" class="media-item">
                      <el-image
                        :src="row[0].FilePath"
                        :preview-src-list="[row[0].FilePath]"
                        fit="cover"
                        class="media-content"
                      />
                    </div>
                    <div v-else-if="row[0].type === 'video'" class="media-item">
                      <!-- PC端视频组件 - 已添加播放按钮 -->
                      <div
                        class="video-wrapper"
                        @click="handleVideoClick(row[0])"
                      >
                        <video
                          :ref="(el) => setVideoRef(`video-${rowIndex}-0`, el)"
                          :data-src="row[0].FilePath"
                          playsinline
                          webkit-playsinline
                          class="media-content"
                        >
                          <source
                            :src="row[0].FilePath"
                            :type="getVideoMimeType(row[0])"
                          />
                          您的浏览器不支持视频播放
                        </video>
                        <div
                          class="video-overlay"
                          :class="{ hidden: playingVideos[row[0].FilePath] }"
                        >
                          <div class="play-icon"></div>
                        </div>
                        <div
                          v-if="loadingVideos[row[0].FilePath]"
                          class="loading-indicator"
                        >
                          <div class="spinner"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 右侧小图垂直排列 -->
                  <div class="right-column">
                    <div class="cell small" v-if="row[1]">
                      <div v-if="row[1].type === 'image'" class="media-item">
                        <el-image
                          :src="row[1].FilePath"
                          :preview-src-list="[row[1].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[1].type === 'video'"
                        class="media-item"
                      >
                        <!-- PC端视频组件 - 已添加播放按钮 -->
                        <div
                          class="video-wrapper"
                          @click="handleVideoClick(row[1])"
                        >
                          <video
                            :ref="
                              (el) => setVideoRef(`video-${rowIndex}-1`, el)
                            "
                            :data-src="row[1].FilePath"
                            playsinline
                            webkit-playsinline
                            class="media-content"
                          >
                            <source
                              :src="row[1].FilePath"
                              :type="getVideoMimeType(row[1])"
                            />
                            您的浏览器不支持视频播放
                          </video>
                          <div
                            class="video-overlay"
                            :class="{ hidden: playingVideos[row[1].FilePath] }"
                          >
                            <div class="play-icon"></div>
                          </div>
                          <div
                            v-if="loadingVideos[row[1].FilePath]"
                            class="loading-indicator"
                          >
                            <div class="spinner"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="cell small" v-if="row[2]">
                      <div v-if="row[2].type === 'image'" class="media-item">
                        <el-image
                          :src="row[2].FilePath"
                          :preview-src-list="[row[2].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[2].type === 'video'"
                        class="media-item"
                      >
                        <!-- PC端视频组件 - 已添加播放按钮 -->
                        <div
                          class="video-wrapper"
                          @click="handleVideoClick(row[2])"
                        >
                          <video
                            :ref="
                              (el) => setVideoRef(`video-${rowIndex}-2`, el)
                            "
                            :data-src="row[2].FilePath"
                            playsinline
                            webkit-playsinline
                            class="media-content"
                          >
                            <source
                              :src="row[2].FilePath"
                              :type="getVideoMimeType(row[2])"
                            />
                            您的浏览器不支持视频播放
                          </video>
                          <div
                            class="video-overlay"
                            :class="{ hidden: playingVideos[row[2].FilePath] }"
                          >
                            <div class="play-icon"></div>
                          </div>
                          <div
                            v-if="loadingVideos[row[2].FilePath]"
                            class="loading-indicator"
                          >
                            <div class="spinner"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- 模式B：左小图水平排列 + 右大图（奇数行） -->
              <template v-else>
                <div class="pattern-b">
                  <!-- 左侧小图水平排列 -->
                  <div class="left-column">
                    <div class="cell small" v-if="row[0]">
                      <div v-if="row[0].type === 'image'" class="media-item">
                        <el-image
                          :src="row[0].FilePath"
                          :preview-src-list="[row[0].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[0].type === 'video'"
                        class="media-item"
                      >
                        <!-- PC端视频组件 - 已添加播放按钮 -->
                        <div
                          class="video-wrapper"
                          @click="handleVideoClick(row[0])"
                        >
                          <video
                            :ref="
                              (el) => setVideoRef(`video-${rowIndex}-0`, el)
                            "
                            :data-src="row[0].FilePath"
                            playsinline
                            webkit-playsinline
                            class="media-content"
                          >
                            <source
                              :src="row[0].FilePath"
                              :type="getVideoMimeType(row[0])"
                            />
                            您的浏览器不支持视频播放
                          </video>
                          <div
                            class="video-overlay"
                            :class="{ hidden: playingVideos[row[0].FilePath] }"
                          >
                            <div class="play-icon"></div>
                          </div>
                          <div
                            v-if="loadingVideos[row[0].FilePath]"
                            class="loading-indicator"
                          >
                            <div class="spinner"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="cell small" v-if="row[1]">
                      <div v-if="row[1].type === 'image'" class="media-item">
                        <el-image
                          :src="row[1].FilePath"
                          :preview-src-list="[row[1].FilePath]"
                          fit="cover"
                          class="media-content"
                        />
                      </div>
                      <div
                        v-else-if="row[1].type === 'video'"
                        class="media-item"
                      >
                        <!-- PC端视频组件 - 已添加播放按钮 -->
                        <div
                          class="video-wrapper"
                          @click="handleVideoClick(row[1])"
                        >
                          <video
                            :ref="
                              (el) => setVideoRef(`video-${rowIndex}-1`, el)
                            "
                            :data-src="row[1].FilePath"
                            playsinline
                            webkit-playsinline
                            class="media-content"
                          >
                            <source
                              :src="row[1].FilePath"
                              :type="getVideoMimeType(row[1])"
                            />
                            您的浏览器不支持视频播放
                          </video>
                          <div
                            class="video-overlay"
                            :class="{ hidden: playingVideos[row[1].FilePath] }"
                          >
                            <div class="play-icon"></div>
                          </div>
                          <div
                            v-if="loadingVideos[row[1].FilePath]"
                            class="loading-indicator"
                          >
                            <div class="spinner"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 右侧大图 -->
                  <div class="cell large" v-if="row[2]">
                    <div v-if="row[2].type === 'image'" class="media-item">
                      <el-image
                        :src="row[2].FilePath"
                        :preview-src-list="[row[2].FilePath]"
                        fit="cover"
                        class="media-content"
                      />
                    </div>
                    <div v-else-if="row[2].type === 'video'" class="media-item">
                      <!-- PC端视频组件 - 已添加播放按钮 -->
                      <div
                        class="video-wrapper"
                        @click="handleVideoClick(row[2])"
                      >
                        <video
                          :ref="(el) => setVideoRef(`video-${rowIndex}-2`, el)"
                          :data-src="row[2].FilePath"
                          playsinline
                          webkit-playsinline
                          class="media-content"
                        >
                          <source
                            :src="row[2].FilePath"
                            :type="getVideoMimeType(row[2])"
                          />
                          您的浏览器不支持视频播放
                        </video>
                        <div
                          class="video-overlay"
                          :class="{ hidden: playingVideos[row[2].FilePath] }"
                        >
                          <div class="play-icon"></div>
                        </div>
                        <div
                          v-if="loadingVideos[row[2].FilePath]"
                          class="loading-indicator"
                        >
                          <div class="spinner"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部导航 -->
      <footer class="header-navbar">
        <!-- 第一行：LOGO和导航项 -->
        <div class="top-nav" style="height: 28px !important">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #cccccc;
            margin-top: 15px;
            margin-bottom: 18px;
          "
        ></div>
        <!-- 间距30px后的邮件信息 -->
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">203 Blackburn Rd Mount Waverley VIC 3149</div>
        </div>
      </footer>
    </div>
    <div
      v-else
      style="
        width: 100%;
        border: 1px solid #f8f9fa;
        overflow: hidden;
        position: relative;
        background: white;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%"
          src="../assets/Battertimg/H5/casetop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 28px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%; /* 继承父级宽度 */
              text-align: center; /* 文本水平居中 */
            "
          >
            Gallery
          </div>
        </div>
      </div>
      <!-- 移动端动态布局部分 -->
      <!-- 移动端动态布局部分 -->
      <div
        style="
          width: 100%;
          padding-left: 10px;
          padding-right: 10px;
          margin-top: 30px;
          margin-bottom: 30px;
        "
      >
        <div
          v-for="(row, rowIndex) in groupedRows"
          :key="rowIndex"
          class="mobile-row"
        >
          <!-- 模式A：左大图(60%) + 右小图垂直(各占20%高度) -->
          <template v-if="rowIndex % 2 === 0">
            <div class="mobile-pattern-a">
              <!-- 左侧大图 - 占60%宽度 -->
              <div class="mobile-cell mobile-large" v-if="row[0]">
                <div v-if="row[0].type === 'image'" class="media-item">
                  <el-image
                    :src="row[0].FilePath"
                    :preview-src-list="[row[0].FilePath]"
                    fit="cover"
                    class="media-content"
                  />
                </div>
                <div v-else-if="row[0].type === 'video'" class="media-item">
                  <!-- 修改后的视频组件 -->
                  <div class="video-wrapper" @click="handleVideoClick(row[0])">
                    <video
                      :data-src="row[0].FilePath"
                      :ref="(el) => setMobileVideoRef(rowIndex, 0, el)"
                      playsinline
                      webkit-playsinline
                      x5-playsinline
                      x5-video-player-type="h5"
                      x5-video-player-fullscreen="true"
                      :poster="row[0].generatedPoster || row[0].poster"
                      preload="metadata"
                      class="media-content"
                      @loadeddata="onMobileVideoLoaded($event, rowIndex, 0)"
                    >
                      <source
                        :src="row[0].FilePath"
                        :type="getVideoMimeType(row[0])"
                      />
                      您的浏览器不支持视频播放
                    </video>
                    <div
                      class="video-overlay"
                      :class="{ hidden: playingVideos[row[0].FilePath] }"
                    >
                      <div class="play-icon"></div>
                    </div>
                    <div
                      v-if="loadingVideos[row[0].FilePath]"
                      class="loading-indicator"
                    >
                      <div class="spinner"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 右侧小图垂直排列 - 占40%宽度 -->
              <div class="mobile-right-column">
                <div class="mobile-cell mobile-small" v-if="row[1]">
                  <div v-if="row[1].type === 'image'" class="media-item">
                    <el-image
                      :src="row[1].FilePath"
                      :preview-src-list="[row[1].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[1].type === 'video'" class="media-item">
                    <!-- 修改后的视频组件 -->
                    <div
                      class="video-wrapper"
                      @click="handleVideoClick(row[1])"
                    >
                      <video
                        :data-src="row[1].FilePath"
                        :ref="(el) => setMobileVideoRef(rowIndex, 1, el)"
                        playsinline
                        webkit-playsinline
                        x5-playsinline
                        x5-video-player-type="h5"
                        x5-video-player-fullscreen="true"
                        :poster="row[1].generatedPoster || row[1].poster"
                        preload="metadata"
                        class="media-content"
                        @loadeddata="onMobileVideoLoaded($event, rowIndex, 1)"
                      >
                        <source
                          :src="row[1].FilePath"
                          :type="getVideoMimeType(row[1])"
                        />
                        您的浏览器不支持视频播放
                      </video>
                      <div
                        class="video-overlay"
                        :class="{ hidden: playingVideos[row[1].FilePath] }"
                      >
                        <div class="play-icon"></div>
                      </div>
                      <div
                        v-if="loadingVideos[row[1].FilePath]"
                        class="loading-indicator"
                      >
                        <div class="spinner"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mobile-cell mobile-small" v-if="row[2]">
                  <div v-if="row[2].type === 'image'" class="media-item">
                    <el-image
                      :src="row[2].FilePath"
                      :preview-src-list="[row[2].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[2].type === 'video'" class="media-item">
                    <!-- <button @click="manualGeneratePosters" style="background: #f56c6c; color: white; padding: 10px; border: none; border-radius: 5px;">
    手动生成封面
  </button> -->

                    <!-- 修改后的视频组件 -->
                    <div
                      class="video-wrapper"
                      @click="handleVideoClick(row[2])"
                    >
                      <video
                        :data-src="row[2].FilePath"
                        :ref="(el) => setMobileVideoRef(rowIndex, 2, el)"
                        playsinline
                        webkit-playsinline
                        x5-playsinline
                        x5-video-player-type="h5"
                        x5-video-player-fullscreen="true"
                        :poster="row[2].generatedPoster || row[2].poster"
                        preload="metadata"
                        class="media-content"
                        @loadeddata="onMobileVideoLoaded($event, rowIndex, 2)"
                      >
                        <source
                          :src="row[2].FilePath"
                          :type="getVideoMimeType(row[2])"
                        />
                        您的浏览器不支持视频播放
                      </video>
                      <div
                        class="video-overlay"
                        :class="{ hidden: playingVideos[row[2].FilePath] }"
                      >
                        <div class="play-icon"></div>
                      </div>
                      <div
                        v-if="loadingVideos[row[2].FilePath]"
                        class="loading-indicator"
                      >
                        <div class="spinner"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 模式B：左小图水平(各占50%) + 右大图(50%) -->
          <template v-else>
            <div class="mobile-pattern-b">
              <!-- 左侧小图水平排列 - 各占50% -->
              <div class="mobile-left-column">
                <div class="mobile-cell mobile-small" v-if="row[0]">
                  <div v-if="row[0].type === 'image'" class="media-item">
                    <el-image
                      :src="row[0].FilePath"
                      :preview-src-list="[row[0].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[0].type === 'video'" class="media-item">
                    <!-- 修改后的视频组件 -->
                    <div
                      class="video-wrapper"
                      @click="handleVideoClick(row[0])"
                    >
                      <video
                        :data-src="row[0].FilePath"
                        :ref="(el) => setMobileVideoRef(rowIndex, 0, el)"
                        playsinline
                        webkit-playsinline
                        x5-playsinline
                        x5-video-player-type="h5"
                        x5-video-player-fullscreen="true"
                        :poster="row[0].generatedPoster || row[0].poster"
                        preload="metadata"
                        class="media-content"
                        @loadeddata="onMobileVideoLoaded($event, rowIndex, 0)"
                      >
                        <source
                          :src="row[0].FilePath"
                          :type="getVideoMimeType(row[0])"
                        />
                        您的浏览器不支持视频播放
                      </video>
                      <div
                        class="video-overlay"
                        :class="{ hidden: playingVideos[row[0].FilePath] }"
                      >
                        <div class="play-icon"></div>
                      </div>
                      <div
                        v-if="loadingVideos[row[0].FilePath]"
                        class="loading-indicator"
                      >
                        <div class="spinner"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mobile-cell mobile-small" v-if="row[1]">
                  <div v-if="row[1].type === 'image'" class="media-item">
                    <el-image
                      :src="row[1].FilePath"
                      :preview-src-list="[row[1].FilePath]"
                      fit="cover"
                      class="media-content"
                    />
                  </div>
                  <div v-else-if="row[1].type === 'video'" class="media-item">
                    <!-- 修改后的视频组件 -->
                    <div
                      class="video-wrapper"
                      @click="handleVideoClick(row[1])"
                    >
                      <video
                        :data-src="row[1].FilePath"
                        :ref="(el) => setMobileVideoRef(rowIndex, 1, el)"
                        playsinline
                        webkit-playsinline
                        x5-playsinline
                        x5-video-player-type="h5"
                        x5-video-player-fullscreen="true"
                        :poster="row[1].generatedPoster || row[1].poster"
                        preload="metadata"
                        class="media-content"
                        @loadeddata="onMobileVideoLoaded($event, rowIndex, 0)"
                      >
                        <source
                          :src="row[1].FilePath"
                          :type="getVideoMimeType(row[1])"
                        />
                        您的浏览器不支持视频播放
                      </video>
                      <div
                        class="video-overlay"
                        :class="{ hidden: playingVideos[row[1].FilePath] }"
                      >
                        <div class="play-icon"></div>
                      </div>
                      <div
                        v-if="loadingVideos[row[1].FilePath]"
                        class="loading-indicator"
                      >
                        <div class="spinner"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 右侧大图 - 占50% -->
              <div class="mobile-cell mobile-large" v-if="row[2]">
                <div v-if="row[2].type === 'image'" class="media-item">
                  <el-image
                    :src="row[2].FilePath"
                    :preview-src-list="[row[2].FilePath]"
                    fit="cover"
                    class="media-content"
                  />
                </div>
                <div v-else-if="row[2].type === 'video'" class="media-item">
                  <!-- 修改后的视频组件 -->
                  <div class="video-wrapper" @click="handleVideoClick(row[2])">
                    <video
                      :data-src="row[2].FilePath"
                      :ref="(el) => setMobileVideoRef(rowIndex, 2, el)"
                      playsinline
                      webkit-playsinline
                      x5-playsinline
                      x5-video-player-type="h5"
                      x5-video-player-fullscreen="true"
                      :poster="row[2].generatedPoster || row[2].poster"
                      preload="metadata"
                      class="media-content"
                      @loadeddata="onMobileVideoLoaded($event, rowIndex, 0)"
                    >
                      <source
                        :src="row[2].FilePath"
                        :type="getVideoMimeType(row[2])"
                      />
                      您的浏览器不支持视频播放
                    </video>
                    <div
                      class="video-overlay"
                      :class="{ hidden: playingVideos[row[2].FilePath] }"
                    >
                      <div class="play-icon"></div>
                    </div>
                    <div
                      v-if="loadingVideos[row[2].FilePath]"
                      class="loading-indicator"
                    >
                      <div class="spinner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- 自定义全屏容器 -->
      <div v-if="isCustomFullscreen" class="custom-fullscreen">
        <video
          ref="fullscreenVideo"
          class="fullscreen-video"
          :src="currentVideoSrc"
          autoplay
          controls
          playsinline
          webkit-playsinline
        ></video>

        <div class="fullscreen-controls">
          <button class="close-btn" @click="exitCustomFullscreen">
            <i>×</i> Close
          </button>
        </div>
      </div>
      <footer class="mobile-footer-navbar">
        <!-- 垂直排列的容器 -->
        <div class="vertical-container">
          <!-- LOGO区域 -->
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <!-- 导航项区域（手动编写每个项） -->
          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              GALLERY
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <!-- 邮件信息区域 -->
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">info@batteryplant.com.au</div>
            <div class="email-contentmobile">203 Blackburn Rd Mount Waverley VIC 3149</div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { get, post } from "../assets/api/api";
import { CasePageList } from "../assets/api/request.js";
export default {
  props: {
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    return {
      mobileVideoRefs: {},
      videoRefs: {}, // 存储视频引用
      videoPosters: {}, // 存储视频封面
      videoPosterLoading: {}, // 记录封面加载状态
      // 新增数据
      playingVideos: {}, // 记录视频播放状态
      loadingVideos: {}, // 记录视频加载状态
      isCustomFullscreen: false, // 自定义全屏状态
      currentVideoSrc: "", // 当前全屏播放的视频地址
      activeNav: null, // 跟踪当前激活的导航项
      imageList: [],
      picUrlArr: [],
    };
  },
  created() {
    this.getCasePageList();
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    // 添加全屏状态监听
    this.setupFullscreenListeners();
  },
  computed: {
    // 将项目分组为每行3个
    groupedRows() {
      const rows = [];
      for (let i = 0; i < this.picUrlArr.length; i += 3) {
        rows.push(this.picUrlArr.slice(i, i + 3));
      }
      return rows;
    },
  },
  beforeDestroy() {
    // 移除事件监听
    this.removeFullscreenListeners();
  },
  methods: {
    getVideoMimeType(mediaItem) {
      // :type="getVideoMimeType(row[0])"
      // 优先级1: 如果数据中直接提供了有效的 MIME 类型，优先使用
      if (mediaItem.FileFormat && mediaItem.FileFormat.startsWith("video/")) {
        return mediaItem.FileFormat;
      }
      // 优先级2: 根据文件扩展名推断
      const filePath = mediaItem.FilePath || "";
      const fileName = mediaItem.FileName || "";
      // 尝试从FilePath或FileName中提取扩展名
      const nameToCheck = filePath || fileName;
      if (!nameToCheck) {
        return "video/mp4"; // 或根据您的需求返回 null/空字符串
      }
      const extension = nameToCheck.split(".").pop().toLowerCase();

      // 扩展名到 MIME 类型的映射表
      const mimeMap = {
        // 最兼容的格式
        mp4: "video/mp4",
        m4v: "video/mp4",
        // 苹果设备格式
        mov: "video/quicktime",
        // 华为等设备可能出现的格式
        mpg: "video/mpeg",
        mpeg: "video/mpeg",
        // 其他网络常见格式
        webm: "video/webm",
        ogg: "video/ogg",
        ogv: "video/ogg",
        // 更多扩展名支持
        avi: "video/x-msvideo",
        wmv: "video/x-ms-wmv",
        flv: "video/x-flv",
        mkv: "video/x-matroska",
        "3gp": "video/3gpp",
      };
      // 返回匹配的 MIME 类型，如果未知则默认为 mp4
      return mimeMap[extension] || "video/mp4";
    },
    // 设置移动端视频引用
    setMobileVideoRef(rowIndex, position, el) {
      if (el) {
        const refName = `mobile-${rowIndex}-${position}`;
        this.$set(this.mobileVideoRefs, refName, el);
        console.log(`✅ 设置移动端视频引用: ${refName}`);
      }
    },
    // 获取移动端视频元素
    getMobileVideoElement(rowIndex, position) {
      const refName = `mobile-${rowIndex}-${position}`;
      return this.mobileVideoRefs[refName];
    },

    // 移动端视频加载完成
    onMobileVideoLoaded(event, rowIndex, position) {
      const videoElement = event.target;
      // console.log("通过事件获取视频元素:", videoElement);

      // 同时设置到 refs 中，方便后续使用
      const refName = `mobile-${rowIndex}-${position}`;
      this.$set(this.mobileVideoRefs, refName, videoElement);

      // 生成封面
      this.generateVideoPosterForElement(videoElement, rowIndex, position);
    },
    async generateVideoPosterForElement(videoElement, rowIndex, position) {
      // console.log('🚀 generateVideoPosterForElement 开始执行', {
      //   rowIndex,
      //   position,
      //   videoElement: !!videoElement,
      //   videoElementTag: videoElement?.tagName,
      //   videoElementSrc: videoElement?.src || videoElement?.getAttribute('data-src'),
      //   readyState: videoElement?.readyState
      // });

      try {
        const globalIndex = rowIndex * 3 + position;
        const item = this.picUrlArr[globalIndex];

        // console.log('📋 数据项信息:', {
        //   globalIndex,
        //   itemExists: !!item,
        //   itemType: item?.type,
        //   hasGeneratedPoster: item?.generatedPoster,
        //   item
        // });

        if (!item || item.type !== "video" || item.generatedPoster) {
          console.log("⏭️ 跳过生成封面: 条件不满足");
          return;
        }

        // 确保视频已加载足够数据
        // console.log('📥 检查视频 readyState:', videoElement.readyState);
        if (videoElement.readyState < 2) {
          // console.log('⏳ 等待视频 canplay 事件...');
          await new Promise((resolve) => {
            videoElement.addEventListener("canplay", resolve, { once: true });
            // 超时保护
            setTimeout(resolve, 3000);
          });
        }

        // console.log('✅ 视频 readyState:', videoElement.readyState);
        // console.log('🎬 视频尺寸:', {
        //   videoWidth: videoElement.videoWidth,
        //   videoHeight: videoElement.videoHeight
        // });

        // 设置当前时间为0.1秒获取第一帧
        videoElement.currentTime = 0.1;
        console.log("⏰ 设置 currentTime 为 0.1");

        await new Promise((resolve) => {
          const onSeeked = () => {
            console.log("✅ seeked 事件触发");
            videoElement.removeEventListener("seeked", onSeeked);
            resolve();
          };
          videoElement.addEventListener("seeked", onSeeked);

          // 设置超时，避免永远等待
          setTimeout(() => {
            console.log("⚠️ seeked 事件超时，继续执行");
            videoElement.removeEventListener("seeked", onSeeked);
            resolve();
          }, 1000);
        });

        // 生成封面
        // console.log('🎨 开始生成封面...');
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth || 300;
        canvas.height = videoElement.videoHeight || 200;

        // console.log('🖼️ Canvas 尺寸:', {
        //   width: canvas.width,
        //   height: canvas.height
        // });

        const ctx = canvas.getContext("2d");

        // 检查是否可以绘制
        // console.log('🖌️ 检查 canvas 上下文:', !!ctx);

        if (canvas.width > 0 && canvas.height > 0 && ctx) {
          try {
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            // console.log('✅ drawImage 成功');

            // 检查 canvas 是否真的有内容
            const imageData = ctx.getImageData(0, 0, 1, 1);
            // console.log('🎯 Canvas 像素检查:', {
            //   hasData: !!imageData.data,
            //   dataLength: imageData.data?.length
            // });

            // 转换为 Blob URL
            canvas.toBlob(
              async (blob) => {
                console.log("📦 toBlob 回调执行:", {
                  blobExists: !!blob,
                  blobSize: blob?.size,
                  blobType: blob?.type,
                });

                if (blob) {
                  const posterBlobUrl = URL.createObjectURL(blob);
                  console.log("🔗 生成 Blob URL:", posterBlobUrl);

                  // 更新对应项
                  this.$set(this.picUrlArr, globalIndex, {
                    ...item,
                    generatedPoster: posterBlobUrl,
                    generatedPosterType: "blob",
                  });

                  // console.log(`✅ 生成封面成功 (Blob URL): 行${rowIndex}-位置${position}`);

                  // 显示成功消息
                  // this.$nextTick(() => {
                  //   this.$message.success(`✅ 生成封面成功: 行${rowIndex}-位置${position}`);
                  // });

                  // 直接设置到视频元素
                  this.$nextTick(() => {
                    if (videoElement && videoElement.tagName === "VIDEO") {
                      videoElement.poster = posterBlobUrl;
                      // console.log(`🎯 设置 Blob URL 到 video.poster`);
                    }
                  });
                } else {
                  // console.log('❌ toBlob 返回 null');
                  // 备用：使用 Base64
                  const posterDataURL = canvas.toDataURL("image/jpeg", 0.8);
                  // console.log('📸 使用 Base64 作为备用:', posterDataURL?.substring(0, 50) + '...');

                  this.$set(this.picUrlArr, globalIndex, {
                    ...item,
                    generatedPoster: posterDataURL,
                    generatedPosterType: "base64",
                  });

                  // this.$nextTick(() => {
                  //   this.$message.success(`✅ 生成封面成功 (Base64): 行${rowIndex}-位置${position}`);
                  // });
                }
              },
              "image/jpeg",
              0.8
            );
          } catch (drawError) {
            console.error("❌ drawImage 失败:", drawError);
          }
        } else {
          console.log("❌ Canvas 尺寸无效或上下文获取失败");
        }
      } catch (error) {
        console.error("❌ 生成封面失败:", error);
        // this.$nextTick(() => {
        //   this.$message.error(`生成封面失败: ${error.message}`);
        // });
      }
    },

    // 修改后的 generateVideoPoster 方法
    generateVideoPoster(index) {
      // 计算行和位置
      const rowIndex = Math.floor(index / 3);
      const position = index % 3;

      // 根据设备类型获取视频元素
      const isMobile = this.offsetwidth <= 850;
      const videoElement = isMobile
        ? this.getMobileVideoElement(rowIndex, position)
        : this.getVideoElement(rowIndex, position); // PC端使用原有方法

      if (!videoElement) {
        console.warn(
          `视频元素未找到: 全局索引${index}, 行${rowIndex}, 位置${position}`
        );
        return Promise.resolve();
      }

      return this.generateVideoPosterForElement(
        videoElement,
        rowIndex,
        position
      );
    },
    // 添加手动触发方法
    manualGeneratePosters() {
      // console.log("🔄 手动触发封面生成");
      this.generateAllVideoPosters();
    },
    // 设置全屏监听器
    setupFullscreenListeners() {
      this.handleFullscreenChange = () => {
        const wasFullscreen = this.isFullscreen;
        this.isFullscreen = !!(
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement
        );

        // console.log("全屏状态变化:", this.isFullscreen);

        // 如果从全屏退出
        if (wasFullscreen && !this.isFullscreen) {
          this.handleFullscreenExit();
        }
      };

      document.addEventListener(
        "fullscreenchange",
        this.handleFullscreenChange
      );
      document.addEventListener(
        "webkitfullscreenchange",
        this.handleFullscreenChange
      );
    },

    // 移除全屏监听器
    removeFullscreenListeners() {
      if (this.handleFullscreenChange) {
        document.removeEventListener(
          "fullscreenchange",
          this.handleFullscreenChange
        );
        document.removeEventListener(
          "webkitfullscreenchange",
          this.handleFullscreenChange
        );
      }
    },

    // 处理全屏退出
    handleFullscreenExit() {
      // console.log("处理全屏退出");

      // 重置所有视频的播放状态，确保按钮重新显示
      Object.keys(this.playingVideos).forEach((key) => {
        this.$set(this.playingVideos, key, false);
      });

      this.currentPlayingVideo = null;

      // 如果使用自定义全屏，也退出
      if (this.isCustomFullscreen) {
        this.isCustomFullscreen = false;
      }
    },

    // 视频点击处理方法
    handleVideoClick(videoItem) {
      const videoSrc = videoItem.FilePath;
      // console.log("点击视频:", videoSrc);

      // 如果已经在播放，点击暂停
      if (this.playingVideos[videoSrc]) {
        this.pauseVideo(videoSrc);
        return;
      }

      this.currentPlayingVideo = videoSrc;
      this.currentVideoSrc = videoSrc;

      // 移动端直接使用自定义全屏，避免双重全屏
      if (this.isMobileDevice()) {
        this.enterCustomFullscreen();
      } else {
        this.playAndEnterFullscreen(videoSrc);
      }
    },
    // 在视频加载时设置封面
    setupVideoPoster(videoElement, videoSrc) {
      if (this.videoPosters[videoSrc]) return;

      videoElement.addEventListener("loadeddata", () => {
        // 尝试捕获第一帧作为封面
        setTimeout(() => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

            // 检查canvas是否有有效内容
            if (canvas.width > 0 && canvas.height > 0) {
              this.$set(this.videoPosters, videoSrc, canvas.toDataURL());
            }
          } catch (error) {
            console.log("捕获视频封面失败:", error);
          }
        }, 100);
      });
    },
    // 播放并进入全屏
    async playAndEnterFullscreen(videoSrc) {
      this.$set(this.loadingVideos, videoSrc, true);

      try {
        const videoElement = this.findVideoElement(videoSrc);
        if (!videoElement) {
          console.log("未找到视频元素");
          return;
        }
        console.log(videoElement, videoSrc);
        // 设置封面
        this.setupVideoPoster(videoElement, videoSrc);
        // 播放视频
        await videoElement.play();
        this.$set(this.playingVideos, videoSrc, true);
        this.$set(this.loadingVideos, videoSrc, false);

        console.log("视频播放成功，尝试全屏");

        // 进入全屏
        this.enterFullscreen(videoElement, videoSrc);
      } catch (error) {
        console.log("播放失败:", error);
        this.$set(this.loadingVideos, videoSrc, false);
        this.$set(this.playingVideos, videoSrc, false);
      }
    },
    // 暂停视频
    pauseVideo(videoSrc) {
      const videoElement = this.findVideoElement(videoSrc);
      if (videoElement) {
        videoElement.pause();
        this.$set(this.playingVideos, videoSrc, false);
        this.currentPlayingVideo = null;
      }
    },

    // 查找视频元素
    findVideoElement(videoSrc) {
      const videos = document.querySelectorAll(`video[data-src="${videoSrc}"]`);
      return videos.length > 0 ? videos[0] : null;
    },
    // 播放视频
    playVideo(videoSrc) {
      this.$set(this.loadingVideos, videoSrc, true);

      // 这里可以添加实际的视频播放逻辑
      // 由于移动端限制，我们主要依赖全屏后的自动播放
      setTimeout(() => {
        this.$set(this.loadingVideos, videoSrc, false);
        this.$set(this.playingVideos, videoSrc, true);
      }, 500);
    },

    // 进入全屏
    enterFullscreen(video, videoSrc) {
      if (this.isMobileDevice()) {
        this.requestMobileFullscreen(video, videoSrc);
      } else {
        this.requestDesktopFullscreen(video);
      }
    },

    // 移动端全屏请求
    requestMobileFullscreen(video, videoSrc) {
      console.log("移动端全屏请求");

      const fullscreenMethods = [
        () => video.webkitEnterFullscreen && video.webkitEnterFullscreen(),
        () => video.requestFullscreen && video.requestFullscreen(),
        () => video.webkitRequestFullscreen && video.webkitRequestFullscreen(),
        () => video.mozRequestFullScreen && video.mozRequestFullScreen(),
      ];

      let fullscreenSuccess = false;
      for (const method of fullscreenMethods) {
        try {
          const result = method.call(video);
          if (result !== undefined) {
            fullscreenSuccess = true;
            this.isFullscreen = true;
            console.log("移动端全屏成功");
            break;
          }
        } catch (e) {
          console.log("全屏方法失败:", e);
        }
      }

      // 如果全屏API不可用，使用自定义全屏
      if (!fullscreenSuccess) {
        console.log("使用自定义全屏");
        this.enterCustomFullscreen();
      }
    },

    // PC端全屏处理
    requestDesktopFullscreen(video) {
      if (!document.fullscreenElement) {
        video.requestFullscreen().catch((e) => {
          console.error("全屏失败:", e);
          this.$set(this.playingVideos, this.currentPlayingVideo, false);
        });
      } else {
        document.exitFullscreen();
      }
    },

    // 进入自定义全屏
    enterCustomFullscreen() {
      this.isCustomFullscreen = true;
      this.isFullscreen = true;

      // 等待DOM更新后播放全屏视频
      this.$nextTick(() => {
        const fullscreenVideo = this.$refs.fullscreenVideo;
        if (fullscreenVideo) {
          fullscreenVideo.play().catch((e) => {
            console.log("全屏视频播放失败:", e);
          });
        }
      });
    },

    // 退出自定义全屏 - 修复版本
    exitCustomFullscreen() {
      console.log("退出自定义全屏");
      this.isCustomFullscreen = false;
      this.isFullscreen = false;

      // 重置播放状态，确保按钮重新显示
      if (this.currentPlayingVideo) {
        this.$set(this.playingVideos, this.currentPlayingVideo, false);

        // 暂停原视频
        const videoElement = this.findVideoElement(this.currentPlayingVideo);
        if (videoElement) {
          videoElement.pause();
          videoElement.currentTime = 0; // 重置播放进度
        }

        this.currentPlayingVideo = null;
      }
    },

    // 检测是否为移动设备
    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    // PC端的toggleFullscreen方法 - 修复版本
    toggleFullscreen(event) {
      const video = event.target;
      const videoSrc = video.getAttribute("data-src") || video.currentSrc;

      // 更新当前播放的视频
      this.currentPlayingVideo = videoSrc;

      // 播放/暂停切换
      if (video.paused) {
        video
          .play()
          .then(() => {
            this.$set(this.playingVideos, videoSrc, true);
          })
          .catch((e) => {
            console.log("播放失败:", e);
            this.$set(this.playingVideos, videoSrc, false);
          });
      } else {
        video.pause();
        this.$set(this.playingVideos, videoSrc, false);
      }

      // 全屏请求
      if (document.fullscreenEnabled) {
        if (!document.fullscreenElement) {
          video.requestFullscreen().catch((e) => {
            console.error("全屏失败:", e);
            this.$set(this.playingVideos, videoSrc, false);
          });
        } else {
          document.exitFullscreen();
        }
      }
    },

    addTypeToMediaItems(data) {
      return data.map((item) => {
        let type = "unknown";

        try {
          if (item.FileFormat) {
            if (item.FileFormat.startsWith("image/")) {
              type = "image";
            } else if (item.FileFormat.startsWith("video/")) {
              type = "video";
            } else {
              // 备用方案：根据文件扩展名判断
              const fileName = item.FileName || "";
              const extension = fileName.split(".").pop().toLowerCase();
              const imageExtensions = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "bmp",
                "webp",
                "svg",
              ];
              const videoExtensions = [
                "mp4",
                "avi",
                "mov",
                "wmv",
                "flv",
                "webm",
                "mkv",
              ];

              if (imageExtensions.includes(extension)) {
                type = "image";
              } else if (videoExtensions.includes(extension)) {
                type = "video";
              }
            }
          }
        } catch (error) {
          console.warn("处理文件类型时出错:", error, item);
        }

        return {
          ...item,
          type: type,
        };
      });
    },
    // 获取视频封面
    getVideoPoster(videoItem) {
      const videoSrc = videoItem.FilePath;

      // 如果已经有生成的封面，直接返回
      if (this.videoPosters[videoSrc]) {
        return this.videoPosters[videoSrc];
      }

      // 如果没有封面且没有在加载，开始生成封面
      if (!this.videoPosterLoading[videoSrc]) {
        this.generateVideoPoster(videoSrc);
      }

      // 返回空或者默认封面
      return ""; // 或者返回一个默认封面图片
    },
    // 修改 setVideoRef 方法，添加更多调试信息
    setVideoRef(refName, el) {
      if (el) {
        // console.log(`✅ 设置视频引用: ${refName}`, {
        //   tagName: el.tagName,
        //   src: el.src || el.getAttribute('data-src'),
        //   parentElement: el.parentElement?.className
        // });
        this.$set(this.videoRefs, refName, el);
      } else {
        // console.log(`❌ 清除视频引用: ${refName}`);
        this.$delete(this.videoRefs, refName);
      }
    },
    // 获取视频元素
    getVideoElement(rowIndex, position) {
      const refName = `video-${rowIndex}-${position}`;
      return this.videoRefs[refName];
    },

    // 立即生成视频封面
    async generateVideoPosterNow(videoElement, rowIndex, position) {
      try {
        // 等待视频准备好
        if (videoElement.readyState < 2) {
          // 至少需要HAVE_CURRENT_DATA
          await new Promise((resolve) => {
            videoElement.addEventListener("canplay", resolve, { once: true });
          });
        }

        // 设置当前时间为0以获取第一帧
        videoElement.currentTime = 0;

        // 等待视频跳转到指定时间
        await new Promise((resolve) => {
          const onSeeked = () => {
            videoElement.removeEventListener("seeked", onSeeked);
            resolve();
          };
          videoElement.addEventListener("seeked", onSeeked);

          // 设置超时
          setTimeout(resolve, 1000);
        });

        // 生成封面
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth || 300;
        canvas.height = videoElement.videoHeight || 200;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

        // 如果canvas有内容，设置为封面
        if (canvas.width > 0 && canvas.height > 0) {
          const posterDataURL = canvas.toDataURL("image/jpeg", 0.7);

          // 更新对应数据项
          const row = this.groupedRows[rowIndex];
          if (row && row[position]) {
            // 使用 Vue.set 确保响应式更新
            this.$set(this.picUrlArr, this.findVideoIndex(rowIndex, position), {
              ...row[position],
              generatedPoster: posterDataURL,
            });
          }
        }
      } catch (error) {
        console.error("生成视频封面失败:", error);
      }
    },
    // 在picUrlArr中找到对应的视频索引
    findVideoIndex(rowIndex, position) {
      let globalIndex = 0;
      for (let i = 0; i < this.groupedRows.length; i++) {
        const row = this.groupedRows[i];
        for (let j = 0; j < row.length; j++) {
          if (i === rowIndex && j === position) {
            return globalIndex;
          }
          globalIndex++;
        }
      }
      return -1;
    },
    // 修改生成所有封面的方法
    // 生成所有视频封面
    async generateAllVideoPosters() {
      const videoSlides = this.picUrlArr.filter(
        (slide) => slide.type === "video"
      );
      const promises = videoSlides.map((slide, index) =>
        this.generateVideoPoster(this.picUrlArr.indexOf(slide))
      );

      await Promise.allSettled(promises);
    },

    // 处理媒体项类型
    processMediaItems(data) {
      return data.map((item) => {
        let type = "unknown";

        try {
          if (item.FileFormat) {
            if (item.FileFormat.startsWith("image/")) {
              type = "image";
            } else if (item.FileFormat.startsWith("video/")) {
              type = "video";
            } else {
              // 备用方案：根据文件扩展名判断
              const fileName = item.FileName || "";
              const extension = fileName.split(".").pop().toLowerCase();
              const imageExtensions = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "bmp",
                "webp",
                "svg",
              ];
              const videoExtensions = [
                "mp4",
                "avi",
                "mov",
                "wmv",
                "flv",
                "webm",
                "mkv",
              ];

              if (imageExtensions.includes(extension)) {
                type = "image";
              } else if (videoExtensions.includes(extension)) {
                type = "video";
              }
            }
          }
        } catch (error) {
          console.warn("处理文件类型时出错:", error, item);
        }

        // 构建幻灯片对象
        const picUrlArr = {
          ...item,
          type: type,
          loadingPoster: false,
          generatedPoster: null,
        };

        // 如果是视频类型，添加默认封面（如果有的话）
        if (type === "video" && !picUrlArr.poster) {
          // 可以设置一个默认的视频封面图片
          // picUrlArr.poster = require("../assets/default-video-poster.jpg");
        }

        return picUrlArr;
      });
    },

    async getCasePageList() {
      try {
        const res = await get(CasePageList);
        if (res.data.code == 200) {
          // let data = [];
          // data = res.data.case;
          // data.push({
          //   FileFormat: "video/mp4",
          //   FileId: 10035,
          //   FileName: "video",
          //   FilePath: require("../assets/Battertimg/PC/video.mp4"),
          // });
          const result = this.addTypeToMediaItems(res.data.case);
          this.picUrlArr = result;
          const processedData = this.processMediaItems(res.data.case || []);
          this.picUrlArr = processedData;
          // 如果有视频，生成视频封面
          if (this.picUrlArr.some((picUrlArr) => picUrlArr.type === "video")) {
            // 等待DOM渲染完成
            // this.$nextTick(() => {
            //   // 移动端需要更长的延迟，因为视频元素加载较慢
            //   const delay = this.offsetwidth <= 850 ? 1000 : 500;
            //   setTimeout(() => {
            //     // console.log(`延迟 ${delay}ms 后生成封面...`);
            this.generatePostersForAllVideos();
            // }, delay);
            // });
          }
        } else {
          console.error("获取数据失败:", res.data);
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    // 为所有视频生成封面
    generatePostersForAllVideos() {
      // console.log('🎬 开始为所有视频生成封面...');
      // 遍历所有数据项
      this.picUrlArr.forEach((item, index) => {
        if (item.type === "video") {
          const rowIndex = Math.floor(index / 3);
          const position = index % 3;

          // console.log(`处理视频 ${index}: 行${rowIndex}, 位置${position}`);
          // this.$message.success(`处理视频 ${index}: 行${rowIndex}, 位置${position}`)
          // 尝试获取视频元素
          const videoElement = this.getVideoElementForIndex(rowIndex, position);
          if (videoElement) {
            if (!item.generatedPoster) {
              this.generateVideoPosterForElement(
                videoElement,
                rowIndex,
                position
              );
            }
          } else {
            console.warn(`未找到视频元素: 索引${index}`);
            // this.$message.success(`未找到视频元素: 索引${index}`)
            // 延迟重试
            setTimeout(() => {
              const retryElement = this.getVideoElementForIndex(
                rowIndex,
                position
              );
              if (retryElement && !item.generatedPoster) {
                this.generateVideoPosterForElement(
                  retryElement,
                  rowIndex,
                  position
                );
              }
            }, 300);
          }
        }
      });
    },
    // 根据行和位置获取视频元素
    // 根据行和位置获取视频元素（增强版）
    getVideoElementForIndex(rowIndex, position) {
      const isMobile = this.offsetwidth <= 850;

      // 1. 首先尝试通过 ref 获取
      if (isMobile) {
        const refName = `mobile-${rowIndex}-${position}`;
        const videoElement = this.mobileVideoRefs[refName];
        if (videoElement) {
          console.log(`✅ 通过 ref 找到视频: ${refName}`);
          return videoElement;
        }
      } else {
        const refName = `video-${rowIndex}-${position}`;
        const videoElement = this.videoRefs[refName];
        if (videoElement) {
          console.log(`✅ 通过 ref 找到视频: ${refName}`);
          return videoElement;
        }
      }

      // 2. 如果 ref 没找到，通过 data-src 查找
      const row = this.groupedRows[rowIndex];
      if (row && row[position] && row[position].FilePath) {
        const filePath = row[position].FilePath;
        const videoElement = document.querySelector(
          `video[data-src="${filePath}"]`
        );
        if (videoElement) {
          console.log(`✅ 通过 data-src 找到视频: ${filePath}`);
          return videoElement;
        }
      }

      // 3. 如果还找不到，通过 DOM 索引查找
      const allVideos = document.querySelectorAll("video.media-content");
      // 计算这个视频在DOM中的大概位置
      const videoIndex = rowIndex * 3 + position;
      if (allVideos.length > videoIndex) {
        console.log(`✅ 通过 DOM 索引找到视频: 索引${videoIndex}`);
        return allVideos[videoIndex];
      }

      return null;
    },
    loadImages() {
      //   // 实际项目中替换为API调用
      //   const mockData = [
      //     { id: 1, name: "Indoor1", url: "img/imgs/Indoor1.jpg" },
      //     // ...其他测试数据
      //   ];
      //   this.imageList = mockData.map(item => ({
      //     ...item,
      //     url: this.resolveImageUrl(item.url)
      //   }));
      // },
      // resolveImageUrl(relativePath) {
      //   if (relativePath.startsWith('http')) {
      //     return relativePath;
      //   }
      //   // 根据项目配置调整路径解析方式
      //   return new URL(`../assets/${relativePath}`, import.meta.url).href;
    },
    handleImageClick(index) {
      // 确保预览组件已初始化
      this.$nextTick(() => {
        // 获取预览组件实例
        const viewer = document.querySelector(".el-image-viewer");

        if (viewer) {
          // 1. 自动触发放大操作
          this.autoZoom(viewer);

          // 2. 设置初始缩放比例
          setTimeout(() => {
            const img = viewer.querySelector(".el-image-viewer__img");
            if (img) {
              img.style.transform = "scale(1.5)"; // 初始放大1.5倍
            }
          }, 50);
        }
      });
    },
    autoZoom(viewer) {
      // 查找放大按钮并模拟点击
      const zoomInBtn = viewer.querySelector(".el-image-viewer__zoom-in");
      if (zoomInBtn) {
        // 点击两次达到2倍放大效果（可根据需要调整次数）
        zoomInBtn.click();
        setTimeout(() => zoomInBtn.click(), 30);
      }
    },
    // 激活导航项方法
    activateNav(index) {
      this.activeNav = index;
    },
    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");
        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        document.documentElement.scrollTop = 0;
        // this.$router.push("/Case");
        // window.open('https://smartuser.com.au/customerdetails/')
        // this.$router.push("/ProjectGallery")
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");
        this.$router.push("/ContactUs");
      }
    },
    // goinfo() {
    //   // window.sessionStorage.setItem("activeIndex", "/CustomerDetails");
    //   this.$emit("fun", "/CustomerDetails");
    // },
  },
};
</script>
<style>
/* 全局样式 - 放在你的全局CSS文件中 */
/* 增加预览容器尺寸 */
/* .el-image-viewer__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* 设置初始放大比例 */
/* .el-image-viewer__img {
  transform: scale(1.2) !important;
  transition: transform 0.3s ease;
} */

/* 隐藏操作按钮（可选） */
/* .el-image-viewer__btn {
  display: none !important;
} */
</style>
<style>
/* 全屏回退样式 */
.fullscreen-fallback {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: black;
}
</style>
<!-- 新增样式 -->
<style scoped>
/* 视频封面加载状态 */
.video-poster-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}

.video-poster-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* 确保视频元素正确显示封面 */
video.media-content {
  background-color: #f5f7fa; /* 封面加载前的背景色 */
}

/* 当有封面时，确保封面显示 */
video[poster] {
  object-fit: cover;
}
/* 视频包装器 */
.video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/* 视频覆盖层 */
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* background: rgba(0, 0, 0, 0.4); */
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(2px);
  color: white;
  transition: opacity 0.3s;
  border-radius: 12px;
}

.video-overlay.hidden {
  opacity: 0;
}

.play-icon {
  width: 60px;
  height: 60px;
  background: rgb(0 0 0 / 40%) !important;
  border-radius: 50px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  box-shadow: none;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.play-icon:hover {
  opacity: 1;
}
/* 原生风格三角形播放图标 */
.play-icon::before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 10px 20px;
  border-color: transparent transparent transparent white;
}
/* PC端原生风格 */
@media (min-width: 851px) {
  .play-icon {
    width: 70px;
    height: 70px;
  }

  .play-icon::before {
    border-width: 12px 0 12px 24px;
    margin-left: 5px;
  }
}

/* 移动端原生风格 */
@media (max-width: 850px) {
  .play-icon {
    width: 40px;
    height: 40px;
  }
  .play-icon::before {
    border-width: 8px 0 8px 12px;
    margin-left: 3px;
  }
  .mobile-pattern-a .right-column .play-icon {
    transform: translate(-40%, -50%);
  }
}
.tap-hint {
  font-size: 12px;
  font-weight: 500;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* 加载指示器 */
.loading-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  z-index: 10;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 自定义全屏样式 */
.custom-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: black;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.fullscreen-video {
  flex: 1;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.fullscreen-controls {
  position: absolute;
  top: 6%;
  left: 0;
  width: 100%;
  padding: 20px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 10px 25px;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.close-btn i {
  margin-right: 8px;
}

/* 原有样式保持不变 */
/* ... 您原有的所有样式代码 ... */
</style>
<style scoped>
/* 修复模式B左侧视频播放按钮显示问题 */
.mobile-pattern-b .mobile-left-column .media-content {
  position: relative;
  overflow: visible; /* 确保播放按钮可见 */
}

/* 播放按钮定位优化 */
.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
/* 模式A布局 - 精确比例控制 */
.mobile-pattern-a {
  display: flex;
  gap: 10px;
  width: 100%;
  height: 150px; /* 基础高度 */
  margin-bottom: 20px;
}

/* 左侧大图占60%宽度 */
.mobile-pattern-a .mobile-large {
  flex: 3; /* 60%宽度 (3/5) */
  height: 100%; /* 继承父容器高度 */
}

/* 右侧小图容器占40%宽度 */
.mobile-pattern-a .mobile-right-column {
  flex: 2; /* 40%宽度 (2/5) */
  display: flex;
  flex-direction: column;
  height: 100%; /* 继承父容器高度 */

  /* 视觉间距补偿方案 */
  --spacing: 8px; /* 定义间距变量 */
  gap: calc(var(--spacing) / 1); /* 内部间距 */
  padding: calc(var(--spacing) / 2) 0; /* 上下内边距补偿 */
}

/* 右侧每张小图占左侧大图高度的一半 */
.mobile-pattern-a .mobile-small {
  flex: 1; /* 各占50%高度 */
  min-height: calc(50% - var(--spacing)); /* 精确计算：半高减半间间距 */
}

/* 模式B布局 - 精确比例控制 */
.mobile-pattern-b {
  display: flex;
  gap: 10px;
  width: 100%;
  height: 150px; /* 基础高度 */
  margin-bottom: 20px;
}

/* 左侧小图容器占50%宽度 */
.mobile-pattern-b .mobile-left-column {
  flex: 1; /* 50%宽度 */
  display: flex;
  gap: 10px;
  height: 100%;
}

/* 左侧每张小图占50%宽度 */
.mobile-pattern-b .mobile-small {
  flex: 1; /* 各占50%宽度 */
}

/* 右侧大图占50%宽度 */
.mobile-pattern-b .mobile-large {
  flex: 1; /* 50%宽度 */
}

/* 媒体项通用样式 */
.media-item {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f5f7fa;
}

.media-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

/* 响应式高度调整 */
@media (min-width: 480px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 180px;
  }
  /* .mobile-pattern-a .mobile-right-column {
    --spacing: 12px; 
  } */
}

@media (min-width: 768px) {
  .mobile-pattern-a,
  .mobile-pattern-b {
    height: 220px;
  }
  /* .mobile-pattern-a .mobile-right-column {
    --spacing: 12px;
  } */
}

/* 确保视频控件样式一致 */
video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<style scoped>
.image-row {
  /* 这里可以添加额外的行样式，但通常 <el-row> 会有默认的样式 */
  margin: 0; /* 去除行容器的外边距 */
}

.image-col {
  /* 由于我们使用了 :gutter="0"，这里通常不需要额外的间距样式 */
  padding: 0; /* 去除列容器的内边距（虽然 <el-col> 默认可能没有内边距） */
}

.image-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 0; /* 设置图片之间的间距为0 */
  margin: 0; /* 去除容器自身的外边距 */
  padding: 0; /* 去除容器自身的内边距 */
}

.image-container > el-image {
  flex: 0 0 calc(50% - 0px); /* 每列占据50%的宽度，0px是调整间距的，这里不需要额外间距 */
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

.vc_custom_1627269981297copy {
  /* margin-bottom: -40px !important; */
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
}
/* .vc_custom_1626061515335 {
  margin-bottom: -40px !important;
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
} */
/* .special-link {
  text-decoration: underline;
}
a:link {
  color: blue;
} */
/* 已访问的链接 */
/* a:visited {
  color: purple;
} */

/* 鼠标悬浮在链接上 */
/* a:hover {
  color: red;
} */

/* .mt_20 {
  margin-top: 20px;
}
.mt_10 {
  margin-top: 10px;
}
.text_bold {
  font-weight: 700;
}
.pcss {
  font-family: Poppins;
  font-weight: 300;
  font-style: normal;
  font-size: 15px;
}
.titlecss {
  font-family: Poppins;
  font-style: normal;
} */

/* 图片容器相对定位 */
.banner-text {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  z-index: 10;
}

.text-line-1 {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.text-line-2 {
  font-size: clamp(18px, 2.2vw, 36px);
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .banner-text {
    left: 8%;
  }
}

@media (max-width: 992px) {
  .banner-text {
    left: 6%;
  }
}

@media (max-width: 768px) {
  .banner-text {
    left: 5%;
  }

  .text-line-1 {
    font-size: clamp(20px, 4vw, 32px);
  }

  .text-line-2 {
    font-size: clamp(16px, 3vw, 24px);
  }
}
</style>
<style scoped>
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>
<style scoped>
/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}
.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.logo-section,
.nav-section,
.contact-section {
  text-align: left; /* 确保左对齐 */
}
.logo-container {
  margin-bottom: 10px;
}
.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
/* 响应式调整 */
@media (max-width: 480px) {
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
</style>
<style scoped>
/* 基础容器样式 */
.row {
  margin-bottom: 18px;
  width: 100%;
  height: 280px; /* 统一行高 */
}
/* 模式A样式：左大图 + 右小图垂直排列 */
.pattern-a {
  display: flex;
  gap: 18px;
  width: 100%;
  height: 100%; /* 继承行高 */
}

.pattern-a .large {
  flex: 2; /* 占2/3宽度 */
  height: 100%; /* 大图占满整个行高 */
}

.pattern-a .right-column {
  flex: 1; /* 占1/3宽度 */
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%; /* 右列占满整个行高 */
}

.pattern-a .small {
  flex: 1;
  height: calc(50% - 5px); /* 每个小图占右列高度的一半，减去间隙的一半 */
}

/* 模式B样式：左小图水平排列 + 右大图 */
.pattern-b {
  display: flex;
  gap: 18px;
  width: 100%;
  height: 100%; /* 继承行高 */
}

.pattern-b .left-column {
  flex: 1; /* 占50%宽度 */
  display: flex;
  flex-direction: row; /* 水平排列 */
  gap: 18px;
  height: 100%; /* 左列占满整个行高 */
}

.pattern-b .small {
  flex: 1; /* 每个小图占左列宽度的一半 */
  height: 100%; /* 小图占满整个左列高度 */
}

.pattern-b .large {
  flex: 1; /* 占50%宽度 */
  height: 100%; /* 大图占满整个行高 */
}

/* 媒体项样式 */
.media-item {
  width: 100%;
  height: 100%;
  border-radius: 10px; /* 添加圆角 */
  overflow: hidden; /* 确保内容不会超出圆角边界 */
}

.media-content {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例并填满容器 */
  border-radius: 12px; /* 确保图片/视频本身也有圆角 */
}
/* 图片左对齐 */
/* ::v-deep .pattern-a .large .el-image .el-image__inner {
  width: auto !important; 
  height: 100% !important;
  max-width: 100%;
  object-fit: contain !important;
  object-position: left center !important;
}
::v-deep .pattern-a .large .el-image {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: flex-start; 
  align-items: center; 
}
::v-deep .pattern-a .large .el-image .el-image__inner {
  position: relative; 
  width: auto;
  height: 100%;
}  */

/* 响应式调整 */
@media (max-width: 1200px) {
  .row {
    height: 300px; /* 小屏幕时调整行高 */
  }
}

@media (max-width: 850px) {
  .row {
    height: auto; /* 移动端恢复自动高度 */
    flex-direction: column;
  }

  .pattern-a,
  .pattern-b {
    flex-direction: column;
    height: auto;
  }

  .pattern-a .large,
  .pattern-b .large,
  .pattern-a .small,
  .pattern-b .small {
    height: 200px; /* 移动端统一高度 */
  }
}
</style>